import { PageSlug } from "../types"

export const getSlugKey = (slug: PageSlug) => `${slug}-banner-hidden`
